module.exports = __webpack_public_path__ + "img/emoji_04.1be432c8.png";